import axios from 'axios'

export default function useRequest(config = {}, baseUrl = '') {
  return async (endpoint, additionalConfig) => {
    const requestUrl = `${baseUrl}${endpoint}`
    try {
      const response = await axios(
        requestUrl,
        {
          ...config,
          ...additionalConfig,
        },
      )

      if (response && response.data && response.data.errors) {
        throw response
      }
      return response.data
    } catch (e) {
      throw e.data && e.data.errors
    }
  }
}
